import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UUID } from 'angular2-uuid';
import * as Fingerprint2 from 'fingerprintjs2/fingerprint2';

@Injectable()
export class AuthenticationService {
    public token: string;
    public uuid: string;
    info: Object = null;

    constructor(private http: HttpClient,
                private deviceService: DeviceDetectorService) {
        // set token if saved in local storage
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.token = currentUser && currentUser.token;

        const deviceInfo = this.deviceService.getDeviceInfo();

        this.uuid = UUID.UUID();
        Fingerprint2.getV18({}, ((result, components) => {
            this.uuid = result;
            this.info = components;
        }));
    }

    isLoggedIn(): boolean {
        return !!localStorage.getItem('currentUser');
    }

    login(email: string, password: string): Observable<boolean> {

        const deviceInfo = this.deviceService.getDeviceInfo();
        // console.log(deviceInfo)
        let device = deviceInfo['device'];
        if (device === 'unknown') {
            device = null;
            device = deviceInfo['browser'];
        }
        const os = deviceInfo['browser_version'];

        const body = JSON.stringify({
            email: email,
            password: password,
            uuid: this.uuid,
            device: device,
            os: os,
            info: this.info,
        });
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        const url = environment.apiUrl + '/login';

        return this.http.post(url, body, {headers: headers, observe: "response"}).pipe(
            map((response: HttpResponse<any>) => {
                // login successful if there's a jwt token in the response
                const userId = response.body.id;
                const token = response.body.token;
                if (userId && token) {
                    // set token property
                    this.token = token;

                    // store email and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify({id: userId, token: token}));

                    // return true to indicate successful login
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }
            }));
    }

    register(email: string, password: string, firstname: string, lastname: string): Observable<boolean> {

        // let firstname: string = ""; // Brauchen wir hier nicht
        // let lastname: string = ""; // Brauchen wir hier nicht

        const deviceInfo = this.deviceService.getDeviceInfo();
        let device = deviceInfo['device'];
        if (device === 'unknown') {
            device = null;
        }
        const os = deviceInfo['browser'];
        // let language = ""
        // let locale = ""


        const body = JSON.stringify({
            email: email,
            password: password,
            uuid: this.uuid,
            firstname: firstname,
            lastname: lastname,
            device: device,
            os: os,
            info: this.info,
        });
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        const url = environment.apiUrl + '/signup';

        return this.http.post(url, body, {headers: headers, observe: "response"}).pipe(
            map((response: HttpResponse<any>) => {
                // login successful if there's a jwt token in the response
                const userId = response.body.id;
                const token = response.body.token;
                if (token) {
                    // set token property
                    this.token = token;

                    // store email and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify({id: userId, token: token}));

                    // return true to indicate successful login
                    return true;
                } else {
                    // return false to indicate failed login
                    return false;
                }
            }));
    }

    logout(): Observable<boolean> {
        const body = JSON.stringify({
            access_token: this.token,
        });
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        const url = environment.apiUrl + '/logout';

        return this.http.post(url, body, {headers: headers, observe: "response"}).pipe(
            map((response: HttpResponseBase) => {
                this.token = null;
                localStorage.removeItem('currentUser');
                if (response) {
                    return response.status === 200;
                } else {
                    return false;
                }
            }), catchError((error: any) => {
                this.token = null;
                localStorage.removeItem('currentUser');
                const errMsg = (error.message) ? error.message :
                    error.status ? `${error.status} - ${error.statusText}` : 'Server error';
                // console.log(errMsg); // log to console instead
                return observableThrowError(errMsg);
            }));
    }

    forgot(email: string): Observable<boolean> {
        const body = JSON.stringify({email: email});
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        const url = environment.apiUrl + '/forgot';

        return this.http.post(url, body, {headers: headers, observe: "response"}).pipe(
            map((response: HttpResponseBase) => {
                if (response) {
                    return response.status === 200;
                }
            }));
    }

    reset(token: string, password: string): Observable<boolean> {
        const body = JSON.stringify({token: token, password: password});
        const headers = new HttpHeaders({'Content-Type': 'application/json'});
        const url = environment.apiUrl + '/password-reset';

        return this.http.post(url, body, {headers: headers, observe: "response"}).pipe(
            map((response: HttpResponseBase) => {
                if (response) {
                    // console.log(response)
                    return response.status === 204;
                }
            }));
    }

    private handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        const errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        // console.log(errMsg); // log to console instead
        return observableThrowError(errMsg);
    }

}
